<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading">
  <mat-card appearance="outlined">
    <form (ngSubmit)="submit()">
      <mat-form-field>
        <input #compositionTypeTitle
               [(ngModel)]="compositionType.title"
               matInput
               name="title"
               placeholder="Title"
               required>
      </mat-form-field>

      <p>
        <button color="primary"
                mat-raised-button
                type="submit">
          Save
        </button>
      </p>
    </form>
  </mat-card>
</page-content>
